import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Assignment } from './assignment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AdsPlacement } from './ads-placement';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdsPlacementService {
  socket: Socket

  constructor(private httpClient: HttpClient) { }

  public assignments(organizationId?: number): Observable<Assignment[]> {
    return this.httpClient.get<Assignment[]>('/api/media/assignments', organizationId ? { params: new HttpParams({ fromObject: { organization: organizationId } }) } : {});
  }

  public get(adsPlacementId: number): Observable<AdsPlacement> {
    return this.httpClient.get<AdsPlacement>(`/api/media/placements/${adsPlacementId}`);
  }

  public save(adsPlacementId: number, adsPlacement: AdsPlacement): Observable<AdsPlacement> {
    return this.httpClient.post<AdsPlacement>(`/api/media/placements/${adsPlacementId ? adsPlacementId : ''}`, adsPlacement);
  }

  public recent(): Observable<AdsPlacement[]> {
    return this.httpClient.get<AdsPlacement[]>('/api/media/placements/recent');
  }

  public search(params: {}): Observable<AdsPlacement[]> {
    return this.httpClient.get<AdsPlacement[]>('/api/media/placements', { params: new HttpParams({ fromObject: params }) });
  }

  public delete(adsPlacementId: number): Observable<void> {
    return this.httpClient.delete<void>(`/api/media/placements/${adsPlacementId}`);
  }

  public edit(adsPlacementId: number, editPrompt: string): Observable<number[]> {
    return this.httpClient.post<number[]>(`/api/media/placements/${adsPlacementId}/edit`, { editPrompt });
  }

  public editPicture(adsPlacementId: number, productId: number, editPrompt: string): Observable<number[]> {
    return this.httpClient.post<number[]>(`/api/media/placements/${adsPlacementId}/edit/${productId}`, { editPrompt });
  }

  public discardPicture(adsPlacementId: number, productId: number): Observable<void> {
    return this.httpClient.delete<void>(`/api/media/placements/${adsPlacementId}/edit/${productId}`, {});
  }

  public discard(adsPlacementId: number): Observable<void> {
    return this.httpClient.delete<void>(`/api/media/placements/${adsPlacementId}/edit`, {});
  }

  public productPicture(adsPlacementId: number, productId: number): Observable<{ url: string }> {
    return this.httpClient.get<{ url: string }>(`/api/media/placements/${adsPlacementId}/products/${productId}/picture`);
  }

  public statistics(adsPlacementId: number, statistics = {}): Observable<any[]> {
    return this.httpClient.get<any[]>(`/api/media/placements/${adsPlacementId}/statistics`, { params: new HttpParams({ 
      fromObject: statistics 
    }) });
  }

  initSocket(): void {
    this.socket = new Socket({
      url: environment.ws_url,
      options: {
        auth: {
          token: localStorage.getItem('media_access_token')
        }
      }
    })
  }

  listen(): Observable<any> {
    return this.socket.fromEvent('update')
  }
}
